import { toast } from 'react-toastify';

import { ID, Response } from 'app/components/Table/core/types';

import { SensorType } from 'app/modules/system-settings/devices/core/enum';

import { getResponseError } from 'app/helpers/errors';
import { throttle } from 'lodash';

import { API_URL } from 'app/constants/environments';

import { useRackStore } from '../../racks/store';
import { Bin, BinsQueryResponse } from './type';
import axios, { AxiosResponse } from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const BIN_URL = `${API_URL}/api`;
const BIN_URL_V2 = `${API_URL}/api`;
const fetchGetBinInRack = (query: string): Promise<BinsQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios.get(`${BIN_URL_V2}/orgs/${organizationId}/bins-v2?${query}`).then(
    (
      d: AxiosResponse<{
        data: {
          items: Array<Bin>;
          total: number;
        };
      }>,
    ) => {
      useRackStore.getState().setState({ savedItems: [] });
      return {
        data: d.data.data,
      };
    },
  );
};

const getBinInRack = throttle(fetchGetBinInRack, 1000);

const getBin = (binId: ID): Promise<Bin | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${BIN_URL}/orgs/${organizationId}/bins/${binId}`)
    .then((response: AxiosResponse<Response<Bin>>) => response.data)
    .then((response: Response<Bin>) => response.data);
};

const updateBin = (
  binId: ID,
  request: {
    itemId: number;
  },
  type?: SensorType,
): Promise<Bin | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const config = type ? { params: { type } } : {};

  return axios
    .patch(`${BIN_URL}/orgs/${organizationId}/bins/${binId}/items`, request, config)
    .then((response: AxiosResponse<Response<Bin>>) => response.data)
    .then((response: Response<Bin>) => response.data);
};

const updateQuantity = (
  binId: ID,
  request: {
    newQty: number;
    itemId: number;
  },
  callback: () => void,
): Promise<void> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .post(`${BIN_URL}/orgs/${organizationId}/bins/${binId}/set-quantity`, request)
    .then(() => {
      toast.success('Edited quantity successfully!');
      callback();
    })
    .catch((errors) => {
      getResponseError(errors);
    });
};

const deleteBin = async (
  binId: ID,
  itemId: ID,
  onSuccess: () => void,
  onError: (error: any) => void,
  type?: SensorType,
) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const config = type ? { params: { type } } : {};

  axios
    .delete(`${BIN_URL}/orgs/${organizationId}/bins/${binId}/items`, {
      data: {
        itemId: itemId,
      },
      ...config,
    })
    .then(onSuccess)
    .catch(onError);
};

export { getBinInRack, getBin, updateBin, deleteBin, updateQuantity };
